<script setup>
import { useForm } from '@inertiajs/inertia-vue3';
import { Link } from '@inertiajs/inertia-vue3'
</script>
<template>

    <Head>
        <title>Consulta Pública - {{ categoria.nombre }}</title>
    </Head>
    <div class="hero-img-overlay " style="background-image: url('/img/hero-secretarias-direcciones.png');">
        <div class="container">
            <div class="row">
                <div class="col-md-6 col-lg-7">
                    <h1 class="hero-encabezado">Consulta Pública Formulario</h1>
                </div>
            </div>
        </div>
    </div>
    <div class="contenido-wrapper">
        <div class="bloque-general pt-0">
            <div class="container">
                <div class="row">
                    <div class="col-lg-2 text-center text-md-left mb-4"><img :src="'/storage/' + seccion.imagen" alt="" loading="lazy" /></div>
                    <div class="col-lg-10 contenido-administrable text-center text-md-left">
                        <h4>¿Quiéres realizar un comentario acerca del documento?</h4>
                        <div>Queremos escucharte, en este buzón ciudadano podrás indicarnos tus peticiones o dudas sobre la información de esta página municipal. Ingresa tus datos y nosotros nos comunicaremos contigo.</div>
                    </div>
                </div>

                <div class="row mt-5">
                    <div class="col-12 col-md-3">
                        <div class="item">
                            <div class="text p-4">
                                <img src="/img/mejora/file.png" />
                                <div class="titulo font-weight-bold">{{ datos.nombre }}</div>
                                <div class="titulo">{{ categoria.nombre }}</div>
                                <hr noshade="noshade" />
                                <div class="fecha">Vigencia: {{ $filters.getDate(datos.vigencia_consulta) }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-9">
                        <div v-if="!sendit" class="row justify-content-center">
                            <div class="col-lg-12">
                                <form @submit.prevent="submit()">
                                    <h2 class="mt-0">Tus Datos</h2>
                                    <div class="form-group mt-4">
                                        <div style="cursor: pointer;">
                                            <input style="cursor: pointer;" v-model="form.anonimo" type="checkbox" id="anonimo" @change="changeAnonimo">
                                            <label style="cursor: pointer;display:inline;" for="anonimo">Quiero comentar de forma anónima</label>
                                        </div>
                                    </div>
                                    <div class="row" v-if="!form.anonimo">
                                        <div class="col-md-4">
                                            <div class="form-group" :class="{ 'not-valid': form.errors.nombre }">
                                                <label>Nombre(s) <span style="color: red;font-size: 29px;line-height: 0;">*</span></label>
                                                <input v-model="form.nombre" type="text" class="form-control">
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group" :class="{ 'not-valid': form.errors.apellido_paterno }">
                                                <label>Apellido Paterno <span style="color: red;font-size: 29px;line-height: 0;">*</span></label>
                                                <input v-model="form.apellido_paterno" type="text" class="form-control">
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group" :class="{ 'not-valid': form.errors.apellido_paterno }">
                                                <label>Apellido Materno <span style="color: red;font-size: 29px;line-height: 0;">*</span></label>
                                                <input v-model="form.apellido_materno" type="text" class="form-control">
                                            </div>
                                        </div>
                                    </div>
                                    <p style="color: red;line-height: 1.3rem;" v-if="form.anonimo">El teléfono celular y correo electrónico son opcionales si no se proporcionan no se podrá notificar del seguimiento de su queja.</p>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group" :class="{ 'not-valid': form.errors.email }">
                                                <label>Correo electrónico <small v-if="form.anonimo">(opcional)</small> <span v-else style="color: red;font-size: 29px;line-height: 0;">*</span></label>
                                                <input v-model="form.email" type="email" class="form-control">
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group" :class="{ 'not-valid': form.errors.telefono }">
                                                <label>Teléfono celular <small v-if="form.anonimo">(opcional)</small> <span v-else style="color: red;font-size: 29px;line-height: 0;">*</span></label>
                                                <input v-model="form.telefono" minlength="10" maxlength="10" type="tel" class="form-control">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group" :class="{ 'not-valid': form.errors.sector }">
                                                <label>Sector al que pertenece <span style="color: red;font-size: 29px;line-height: 0;">*</span></label>
                                                <select v-model="form.sector" class="form-control form__select">
                                                    <option value="Ciudadano">Ciudadano</option>
                                                    <option value="Académico">Académico</option>
                                                    <option value="Estudiante">Estudiante</option>
                                                    <option value="Empresarial">Empresarial</option>
                                                    <option value="Comercio">Comercio</option>
                                                    <option value="Construcción">Construcción</option>
                                                    <option value="Educación">Educación</option>
                                                    <option value="Salud">Salud</option>
                                                    <option value="Transporte">Transporte</option>
                                                    <option value="Turismo">Turismo</option>
                                                    <option value="ervidor/a público">Servidor/a público</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group" :class="{ 'not-valid': form.errors.rango }">
                                                <label>Rango de edad <span style="color: red;font-size: 29px;line-height: 0;">*</span></label>
                                                <select v-model="form.rango" class="form-control form__select">
                                                    <option value="Menor de 18 años">Menor de 18 años</option>
                                                    <option value="De 19 a 35 años">De 19 a 35 años</option>
                                                    <option value="De 36 a 45 años">De 36 a 45 años</option>
                                                    <option value="De 46 a 59 año">De 46 a 59 años</option>
                                                    <option value="0 años o mas">60 años o mas</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group" :class="{ 'not-valid': form.errors.impacto }">
                                                <label>¿Alguna de las regulaciones propuestas impacta en su vida diaria? <span style="color: red;font-size: 29px;line-height: 0;">*</span></label>
                                                <select v-model="form.impacto" class="form-control form__select">
                                                    <option value="Si">Si</option>
                                                    <option value="No">No</option>
                                                    <option value="No lo se">No lo se</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group" :class="{ 'not-valid': form.errors.comentario }">
                                        <label>En el apartado siguiente, podrás escribir de manera precisa tu opinión, comentario y sugerencia respecto a las propuestas de regulatorias emitidas: <span style="color: red;font-size: 29px;line-height: 0;">*</span></label>
                                        <textarea v-model="form.comentario" class="form-control" rows="5"></textarea>
                                    </div>

                                    <div class="form-group mt-4" :class="{ 'not-valid': form.errors.aviso_de_privacidad }">
                                        <div style="cursor: pointer;">
                                            <input style="cursor: pointer;" v-model="form.aviso_de_privacidad" type="checkbox" id="aviso_de_privacidad">
                                            <label style="display:inline;" for="aviso_de_privacidad">Confirmo que he leído y acepto el <a href="/descargas/avisodeprivacidad.pdf" style="text-decoration: underline;" target="_blank">Aviso de Privacidad</a> <span style="color: red;font-size: 29px;line-height: 0;">*</span></label>
                                        </div>
                                    </div>
                                    <div class="form-group-submit">
                                        <div class="response-output show" v-if="form.hasErrors">
                                            <p>Por favor completa los campos faltantes</p>
                                            <ul>
                                                <li v-for="(error, i) in form.errors" :key="i">{{ error }}</li>
                                            </ul>
                                        </div>
                                        <button type="submit" :disabled="form.processing">{{ (form.processing) ? 'Enviando ...' : 'Enviar comentario/sugerencia' }}</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div class="col-12 text-center" v-else>
                            <div v-if="!send_error">
                                <img loading="lazy" width="99" height="87" class="bloque-form-enviado__icono" src="/img/icono-hexagono-check-dorado.svg" alt="">
                                <h1 class="bloque-form-enviado__encabezado">Tu comentario ha sido enviado de forma exitosa.</h1>
                                <div class="bloque-form-enviado__info">
                                    <p>Cada comentario es importante para nosotros.<br> Gracias por confiar en el Gobierno de Santiago,
                                        Nuevo León.</p>
                                </div>
                                <Link :href="route('consulta-publica')" class="boton-secundario boton-flecha">Regresar a Consulta Pública</Link>
                            </div>
                            <div v-else>
                                <i class="fi fi-close error text-danger"></i>
                                <h1 class="bloque-form-enviado__encabezado">Lo sentimos, ocurrió un error.</h1>
                                <div class="bloque-form-enviado__info">
                                    <p>Tuvimos un error enviando tu comentario, por favor intenta mas tarde.</p>
                                </div>
                                <Link href="" class="boton-secundario boton-flecha">Intentar de nuevo</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        datos: Object,
        seccion: Object,
        categoria: Object,
        sendit: Boolean,
        send_error: Boolean,
    },
    data() {
        return {
            form: useForm({
                anonimo: false,
                aviso_de_privacidad: false,
                archivo_id: this.datos.id,
                tipo: this.categoria.slug,
                nombre: '',
                apellido_paterno: '',
                apellido_materno: '',
                telefono: '',
                email: '',
                sector: '',
                rango: '',
                impacto: '',
                comentario: '',
            }),
        }
    },
    methods: {
        submit() {
            this.form.post(route('consulta.formulario.save', {categoria: this.categoria.slug, id: this.datos.id}), {
                preserveScroll: true,
                onSuccess: () => this.form.reset(),
            });
        },
        changeAnonimo() {
            if (this.form.anonimo) {
                this.form.nombre = this.form.apellido_paterno = this.form.apellido_materno = 'Anónimo';
            } else {
                this.form.nombre = this.form.apellido_paterno = this.form.apellido_materno = '';
            }
        }
    }
}
</script>
<style scoped>
.pre {
    white-space: break-spaces;
}

h2 {
    line-height: 1.3em;
}

.form-group.not-valid select,
.form-group.not-valid textarea {
    border-color: #CD1518;
}

.form-check-label {
    cursor: pointer;
    font-weight: bold;
    margin-bottom: 0;
}

.radio-info {
    display: block;
    font-size: 16px;
    line-height: 1.4em;
}

h4 {
    font-size: 24px;
    font-weight: bold;
}

.item {
    font-size: 1.0625rem;
    background: #FFFFFF;
    box-shadow: .125rem .125rem .625rem 0 rgba(0, 0, 0, 0.23);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-radius: 15px;
}

.item .text {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
}

.item .text .titulo {
    line-height: 1.1em;
    margin-top: 20px;
    text-align: center;
}

.item .fecha {
    font-family: "Playfair Display", Georgia, serif;
    font-size: 16px;
    color: #505050;
    text-align: center;
    display: flex;
    align-items: baseline;
    line-height: 1.3em;
    margin-top: 10px;
}

.item hr {
    border-top: 1px solid #d1d1d1;
    width: 100%;
    margin-bottom: 5px;
    margin-top: 20px;
}
.fi.error {
    font-size: 4rem;
    margin-bottom: 30px;
}

.asterisc {
    color: red;
    font-size: 24px;
    line-height: 0em;
}
.queja {
    padding: 1px 20px 13px;
    background: #faffa687;
    border-radius: 10px;
}
.queja h4{
    line-height: 1.5em;
    font-weight: bold;
    font-size: 18px;
}
</style>
